import { useEffect, useRef, useState } from 'react';

import moment from 'moment';

export const filterCount = (filters) => (
  Object.keys(filters).filter(key =>
    key !== 'page' &&
    key !== 'per_page' &&
    key !== 'sort'
  ).reduce((count, key) => {
    count = Array.isArray(filters[key]) ? (count + filters[key].length) : (filters[key] ? count + 1 : count);
    return count;
  }, 0)
);

export const formatChartMoney = (amount) => {
  if (amount > 1000000)
  {
    return `$${(amount / 1000000).toFixed(1)}M`;
  }
  else if (amount > 1000)
  {
    return `$${(amount / 1000).toFixed(0)}K`;
  }

  return `${amount}`;
};

export const formatDate = (date) => (
  moment(date).format('MM/DD/YYYY')
);

export const formatElectionType = (type) => (
  type.replace('G', 'General ')
      .replace('P', 'Primary ')
      .replace('S', 'Special ')
      .replace('C', 'Convention ')
      .replace('O', 'Other ')
      .replace('R', 'Runoff ')
);

const typeToYear = (type) => (
  parseInt(
    type.replace('G', '')
        .replace('P', '')
        .replace('S', '')
        .replace('C', '')
        .replace('O', '')
        .replace('R', '')
  )
)

export const sortElectionType = (a, b) => (
   typeToYear(b.value) - typeToYear(a.value)
);

export const formatRace = (race) => {
  if (race === 'US-00')
  {
    return 'President';
  }
  else if(race.indexOf('-OO'))
  {
    return race.replace('-00', ' U.S. Senate');
  }

  return race;
};

export const formatOfficeName = (office) => {
  if (office === 'P')
  {
    return 'President';
  }

  if (office === 'H')
  {
    return 'House';
  }

  if (office === 'S')
  {
    return 'Senate';
  }

  return '-';
};

export const formatPartyName = (party) => {
  if (party === 'DEM')
  {
    return 'D';
  }

  if (party === 'REP')
  {
    return 'R';
  }

  return party;
};

export const formatCandidateName = (report) => {
  const partyState = report.candidate_office === 'P' ? formatPartyName(report.candidate_party) : `${formatPartyName(report.candidate_party)}-${report.candidate_office_state}`;
  return `${report.candidate_first_name} ${report.candidate_last_name} - ${formatOfficeName(report.candidate_office)} (${partyState})`;
};

export const formatMoney = (value) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
  return value ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value) : 0
};

export const colors = {
  oppose: '#FF8F45',
  support: '#B2B2B2',
  total: '#FF8F45',
  0: '#C26C32',
  1: '#FF9046',
  2: '#D5f2E3',
  3: '#73BA9B',
  4: '#9F87AE',
  5: '#E3C5FC',
  6: '#B3B3B3',
  7: '#666666',
  8: '#0BA7CC',
  9: '#0DDDFF'
};

export const formatState = (abbr) => {
  const states = {
    "AL": "Alabama",
    "AK": "Alaska",
    "AS": "American Samoa",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "DC": "District Of Columbia",
    "FM": "Federated States Of Micronesia",
    "FL": "Florida",
    "GA": "Georgia",
    "GU": "Guam",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MH": "Marshall Islands",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "MP": "Northern Mariana Islands",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PW": "Palau",
    "PA": "Pennsylvania",
    "PR": "Puerto Rico",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VI": "Virgin Islands",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming"
  };
  return states[abbr] ? states[abbr] : abbr;
};

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState("");
  const firstDebounce = useRef(true);

  useEffect(() => {
    if (value && firstDebounce.current) {
      setDebouncedValue(value);
      firstDebounce.current = false;
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

return debouncedValue;
};
